import CircleStyle from "ol/style/Circle";
import { Feature } from "ol";
import { LineString, Point, Polygon } from "ol/geom";
import { Fill, Stroke, Style } from "ol/style";
import { createEmpty, extend } from "ol/extent";
import { circular } from "ol/geom/Polygon";

export function ConvertDfrToFeatures(dfr, telemetry) {
    // Flight Volume
    if (!dfr.telemetry) {
        return ConvertDfrVolumeToFeatures(dfr);
    }

    // Showing full telemetry that was recorded.
    const getTelemetryFeature = (dfr, telemetry) => {
        const coords = telemetry.map((p) => [p.location.x, p.location.y]);
        const feature = new Feature({ geometry: new LineString(coords), coords, dfr });
        feature.setStyle((feature) => {
            const coords = feature.get("coords");
            return [
                new Style({ stroke: new Stroke({ color: "#4298CA", width: 4 }) }),
                new Style({ geometry: new Point(coords[0]), image: new CircleStyle({ radius: 4, fill: new Fill({ color: "#1b5e20" }) }) }),
                new Style({ geometry: new Point(coords[coords.length - 1]), image: new CircleStyle({ radius: 4, fill: new Fill({ color: "#b71c1c" }) }) })
            ];
        });
        return feature;
    };

    const groups = {};
    for (const tracked of telemetry) {
        const key = tracked.track_uuid;
        if (!groups[key]) {
            groups[key] = [];
        }
        groups[key].push(tracked);
    }

    const features = [];
    for (const group of Object.values(groups)) {
        features.push(getTelemetryFeature(dfr, group));
    }

    return features;
}

export function ConvertDfrVolumeToFeatures(dfr) {
    if (!dfr.volumes || !Array.isArray(dfr.volumes)) {
        return [];
    }

    const features = [];
    const volumes = dfr.volumes;
    for (let i = 0; i < volumes.length; ++i) {
        const volume = volumes[i];

        let geometry;
        if (volume.polygon) {
            const coordinates = [volume.polygon.map(({ lng, lat }) => [lng, lat])];
            geometry = new Polygon(coordinates);
        } else if (volume.circle) {
            const center = [volume.circle.center.lng, volume.circle.center.lat];
            const radius = volume.circle.radius_m;
            geometry = circular(center, radius, 128);
            geometry.set("type", "Circle");
        }

        if (!geometry) {
            continue;
        }

        const feature = new Feature({ geometry, dfr });
        const style = new Style({
            stroke: new Stroke({ color: "#3E436F", width: 2 }),
            fill: new Fill({ color: ConvertHexColorToRgbaColor("#3E436F", 0.5) })
        });
        feature.setStyle(style);
        features.push(feature);
    }
    return features;
}

export function JumpToFeatures(map, features) {
    if (features.length === 0) {
        return;
    }

    const extent = createEmpty();
    features.forEach((feature) => extend(extent, feature.getGeometry().getExtent()));
    map.getView().fit(extent, { maxZoom: 16, padding: [100, 100, 100, 100] });
}

export function ConvertHexColorToRgbaColor(hex, opacity) {
    hex = hex.replace("#", "");

    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}

export function ConvertISOToDate(isoDate) {
    if (!isoDate) {
        return "";
    }

    const date = new Date(isoDate);
    const dateOpts = { day: "2-digit", month: "2-digit", year: "numeric" };
    const timeOpts = { hour12: false, hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: "short" };
    return date.toLocaleDateString("en-US", dateOpts) + " " + date.toLocaleTimeString(navigator.language, timeOpts);
}
